import React, { FC, PropsWithChildren } from 'react';
import { View } from 'react-native';
import { scale } from '@components/frame';
import { SCREEN_BORDER_RADIUS } from '@v2/pages/common/constants/base.constants';
import { MACHINES_NOW_OVERVIEW_BLOCK_CONFIG, TOP_BLOCK_CONFIG } from '@v2/pages/machines/modules/now/components/Overview/constants';
import { BaseTopBlockProps } from '@v2/pages/machines/modules/now/components/Overview/components/TopBlock/types';

const TopBlockHeaderCard: FC<PropsWithChildren<BaseTopBlockProps>> = ({ C, children }) => {
  const { blockBgColor, paddingHorizontal } = MACHINES_NOW_OVERVIEW_BLOCK_CONFIG;
  const { paddingVertical } = TOP_BLOCK_CONFIG;

  return (
    <View
      style={{
        backgroundColor: C(blockBgColor),
        paddingVertical: scale(paddingVertical),
        paddingHorizontal: scale(paddingHorizontal),
        borderTopLeftRadius: scale(SCREEN_BORDER_RADIUS),
        borderTopRightRadius: scale(SCREEN_BORDER_RADIUS),
      }}
    >
      {children}
    </View>
  );
};

export default TopBlockHeaderCard;
